const CONFIGDATA = {
    //renderer
    "rendererClearAlpha": 0,
    //scene & environment
    // "sceneEnvironment": {
    //     "type":"equirectangularMap",
    //     "equiMapPath":"./",
    //     "equiMapFileName":"2k.hdr",
    // },
    "sceneEnvironment": {
        "type":"Equirectangular",
        "equiMapPath":"https://demo-assets.pixotronics.com/pixo/hdr/",
        "equiMapFileName":"gem_2.hdr",
    },
    "sceneBackground": {
        // "backgroundTypeSelection": "environment",
        "backgroundTypeSelection": "color",
        "color": {
            "type":"color",
            "colour":"#d9ccc5",
        },
        "cubeTexture":{
            "type":"cubeTexture",
            "textures": [
                "blizzard_rt.jpg",
                "blizzard_lf.jpg",
                "blizzard_up.jpg",
                "blizzard_dn.jpg",
                "blizzard_bk.jpg",
                "blizzard_ft.jpg"
            ]
        },
        // "cubeTexture":{
        //     "type":"cubeTexture",
        //     "textures": [
        //         "bay_rt.jpg",
        //         "bay_lf.jpg",
        //         "bay_up.jpg",
        //         "bay_dn.jpg",
        //         "bay_bk.jpg",
        //         "bay_ft.jpg"
        //     ]
        // },
        "equiMap":"",
        // // Mountain top
        // "model": {
        //     "type": "3dModel",
        //     "modelPath": "./",
        //     "modelName": "moosstock_mountain_peak_3024_m.glb",
        //     "modelScale": {
        //         "x": 20,
        //         "y": 20,
        //         "z": 20,
        //     },
        //     "modelPosition": {
        //         "x": -2,
        //         "y": -14.7,
        //         "z": 0,
        //     },
        //     "modelRotation": {
        //         "x": 0,
        //         "y": .3,
        //         "z": 0,
        //     },
        // },

        // Modern Garage
        "model": {
            "type": "3dModel",
            "modelPath": "./",
            "modelName": "modern_garage.glb",
            "modelScale": {
                "x": 1,
                "y": 1,
                "z": 1,
            },
            "modelPosition": {
                "x": -2,
                "y": -.6,
                "z": -5,
            },
            "modelRotation": {
                "x": 0,
                "y": .3,
                "z": 0,
            },
        },

        // Parking Garage
        "model": {
            "type": "3dModel",
            "modelPath": "./",
            "modelName": "Parking-lot_01.glb",
            "modelScale": {
                "x": 1,
                "y": 1,
                "z": 1,
            },
            "modelPosition": {
                "x": 0,
                "y": -.55,
                "z": -3.47,
            },
            "modelRotation": {
                "x": 0,
                "y": 0,
                "z": 0,
            },
        }
    },
    "sceneFog":{
        "type": "",
        "color": "",
        "intensity": "",
    },
    "hotspots": {
        "isEnabled" : true,
        "iconType": "individual",
        "hotspotDataFile": "hotspotsData.js",

    },

    // Orbitcontrols

    "orbitControls": {
        "enabled": true,
        "enableDamping": true,
        "dampingFactor": 0.03,
        "zoomSpeed": 0.3,
        "rotateSpeed": 0.9,
        "maxDistance": 6.5,
        "minDistance": 1.5,
        "maxPolarAngle": Math.PI/1.8,
        "enablePan": false
    },

    // Lights

    "lights": [
        // {
        //     "lightName": "ambientLight",
        //     "lightType": "ambient",
        //     "lightIntensity": 0.5,
        //     "lightColor": 0xffffff,
        //     "lightPosition": {},
        //     "lightCastShadow": null,
        //     "lightShadowMapSize": null,
        //     "lightAngle": null,
        //     "lightPneumbra": null,
        //     "lightDecay": null,
        // },
        // {
        //     "lightName": "spotLightMain",
        //     "lightType": "spotLight",
        //     "lightIntensity": 85,
        //     "lightColor": 0xffffff,
        //     "lightPosition": {
        //         "x" : 5.1,
        //         "y" : 2,
        //         "z" : -1.75,
        //     },
        //     "lightCastShadow": true,
        //     "lightShadowMapSize": 256,
        //     "lightAngle": 0.6,
        //     "lightPneumbra": .9,
        //     "lightDecay": 2.36
        // },
        // {
        //     "lightName": "spotLightHighlightFloor",
        //     "lightType": "spotLight",
        //     "lightIntensity": 105,
        //     "lightColor": 0x2a0094,
        //     "lightPosition": {
        //         "x" : 0,
        //         "y" : 4.7,
        //         "z" : 0,
        //     },
        //     "lightCastShadow": false,
        //     "lightShadowMapSize": 256,
        //     "lightAngle": 0.26,
        //     "lightPneumbra": .9,
        //     "lightDecay": 1.43,
        // },
        // {
        //     "lightName": "spotLightWallSide",
        //     "lightType": "spotLight",
        //     "lightIntensity": 50,
        //     "lightColor": 0x2a0094,
        //     "lightPosition": {
        //         "x" : 6.4,
        //         "y" : 10.5,
        //         "z" : 1.68,
        //     },
        //     "lightCastShadow": false,
        //     "lightShadowMapSize": 256,
        //     "lightAngle": 1.4,
        //     "lightPneumbra": .43,
        //     "lightDecay": 1.17,
        //     "lightTarget": {
        //         "x" : 0,
        //         "y" : 2,
        //         "z" : 100,
        //     },
        // },
        // {
        //     "lightName": "spotLightWallMiddle",
        //     "lightType": "spotLight",
        //     "lightIntensity": 50,
        //     // "lightColor": 0x0e00d1,
        //     "lightColor": 0xffffff,
        //     "lightPosition": {
        //         "x" : -0.62,
        //         "y" : 2.7,
        //         "z" : 2.98,
        //     },
        //     "lightCastShadow": false,
        //     "lightShadowMapSize": 256,
        //     "lightAngle": 0.85,
        //     "lightPneumbra": .43,
        //     "lightDecay": 1.17,
        //     "lightTarget": {
        //         "x" : -2,
        //         "y" : 5,
        //         "z" : 10,
        //     },
        // },
        {
            "lightName": "directionalShadow",
            "lightType": "directionalLight",
            "lightIntensity": 3,
            // "lightColor": 0x0e00d1,
            "lightColor": 0xffffff,
            "lightPosition": {
                "x" : 1,
                "y" : 1.5,
                "z" : 2.5,
            },
            "lightCastShadow": true,
            "lightShadowMapSize": 256,
            "lightTarget": {
                "x" : 0,
                "y" : 0,
                "z" : 0,
            },
        },
    ],
    
    // Floor
    // "sceneFloor": {
    //     "type": "model",
    //     "modelPath": "./newAssets/floor/",
    //     "modelName": "landscape 1k_updated mesh.glb",
    //     "modelScale": {
    //         "x": 0.2,
    //         "y": 0.2,
    //         "z": 0.2,
    //     },
    //     "modelPosition": {
    //         "x": 0,
    //         "y": -.475,
    //         "z": 0,
    //     },
    //     "modelRotation": {
    //         "x": 0,
    //         "y": 0,
    //         "z": 0,
    //     },
    // },
    "sceneFloor": {
        "type": "plane",
        "alphaMap" : "./alpha-map-v3.jpg",
        "color": "#d4c7c0",
        "transparent": true,
        "position": {
            "x": 0,
            "y": -0.9,
            "z": 0,
        },
    },
    // Intro animation
    "introAnimation": {
        "animationSequencePoints": [
            // {
            //     "cameraStartPoint": {
            //         "x": -.3,
            //         "y": 1.1,
            //         "z": 1.6,
            //     },
            //     "cameraEndPoint": {
            //         "x": .3,
            //         "y": 1.1,
            //         "z": 1.6,
            //     },
            //     "duration": 5,
            //     "easing": "power3.inOut",
            // },
            // {
            //     "cameraStartPoint": {
            //         "x": 0,
            //         "y": 1.47,
            //         "z": -1.15,
            //     },
            //     "cameraEndPoint": {
            //         "x": 0,
            //         "y": 1.3,
            //         "z": -1.4,
            //     },
            //     "duration": 5,
            //     "easing": "power3.inOut",
            // },
            // {
            //     "cameraStartPoint": {
            //         "x": .6,
            //         "y": .5,
            //         "z": 1.25,
            //     },
            //     "cameraEndPoint": {
            //         "x": .5,
            //         "y": .5,
            //         "z": .75,
            //     },
            //     "duration": 4,
            //     "easing": "none",
            // },
            // {
            //     "cameraStartPoint": {
            //         "x": .3,
            //         "y": 1.5,
            //         "z": -.7,
            //     },
            //     "cameraEndPoint": {
            //         "x": -.2,
            //         "y": 1.5,
            //         "z": -.8,
            //     },
            //     "duration": 4,
            //     "easing": "power1.inOut",
            // },
            // {
            //     "cameraStartPoint": {
            //         "x": -1.25,
            //         "y": 0.5,
            //         "z": .85,
            //     },
            //     "cameraEndPoint": {
            //         "x": -.7,
            //         "y": 0.5,
            //         "z": .85,
            //     },
            //     "duration": 4.5,
            //     "easing": "none",
            // },
            {
                "cameraStartPoint": {
                    "x": -.75,
                    "y": .25,
                    "z": -2,
                },
                "cameraEndPoint": {
                    "x": 0,
                    "y": 1,
                    "z": -3,
                },
                "duration": 4,
                "easing": "power1.inOut",
            },
        ]
    },

    // 3D Object

    "heroProduct": {
        "productName": "bike",
        "product3DModelType": "GLTF",
        "product3DModelPath": "./",
        "product3DModelFileName": "yamaha_explode_animation.glb",
        "product3DModelScale": {
            "x": 1.05,
            "y": 1.05,
            "z": 1.05,
            // "x": .008,
            // "y": .008,
            // "z": .008,
        },
        "product3DModelRotation": {
            "x": 0,
            "y": Math.PI/1.35,
            "z": 0,
        },
        "product3DModelPosition": {
            "x": 0,
            "y": -1,
            "z": 0,
        },
        "product3DModelRecieveShadow": true,
        "product3DModelCastShadow": true,
        "productTickerInfo": [
            "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptatibus, eos?",
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium odio eligendi quo ducimus, possimus labore!",
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel, commodi porro!",
            "Lorem ipsum, dolor sit amet consectetur adipisicing.",
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque modi distinctio, et hic quasi est cumque exercitationem perferendis!",
        ]
    },

    // "heroProduct": {
    //     "productName": "f1car",
    //     "product3DModelType": "GLTF",
    //     "product3DModelPath": "./",
    //     "product3DModelFileName": "WilliamsFW14B_update_06.glb",
    //     "product3DModelScale": {
    //         "x": .71,
    //         "y": .71,
    //         "z": .71,
    //     },
    //     "product3DModelRotation": {
    //         "x": 0,
    //         "y": Math.PI/2,
    //         "z": 0,
    //     },
    //     "product3DModelPosition": {
    //         "x": 0,
    //         "y": -.67,
    //         "z": 0,
    //     },
    //     "product3DModelRecieveShadow": true,
    //     "product3DModelCastShadow": true,
    // },

    // Control panel options
    "controlPanel": {
        // Colours
        "coloursMain": {
            "materials": [
                "Paint.001"
            ],
            "colourOptions": [
                "#ffffff",
                "#D90001",
                "#0a0a0a",
                "#017a22"
            ]
        },
        "xRay": {
            "materials": [
                "Seat.001",
                "Paint.001",
                "Tires.001"
            ]
        }
    },
                
}

export default CONFIGDATA